module.exports = __webpack_public_path__ + "img/E.23396c77.png";